import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

interface ValidatorOptions {
  minimum: number;
  inclusive?: boolean;
  condition?: boolean;
  field: string;
  value: string | number | Date;
}

export function minimumWhenFieldValue(options: ValidatorOptions): ValidatorFn {
  return (control: AbstractControl): ValidationErrors => {
    if (!control || control.value === undefined || control.value === null) {
      return null;
    }

    if (options.condition !== undefined && options.condition === false) {
      return null;
    }

    if (!control || !control.root || !control.parent) {
      return null;
    }

    const fieldValue = control.root.get(options.field).value;

    options.inclusive = options.inclusive ?? false;

    if (fieldValue === options.value) {
      if (options.inclusive) {
        if (control.value <= options.minimum) {
          return { belowMinimum: true, minimum: options.minimum };
        }
      } else {
        if (control.value < options.minimum) {
          return { belowMinimum: true, minimum: options.minimum };
        }
      }
    }

    return null;
  };
}
